var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2372_4122)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.73438,
    y: 0.945312,
    width: 64,
    height: 64,
    rx: 13.3333,
    fill: "#F6EFE9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7232 14.6582C40.1481 14.6582 42.4736 15.6215 44.1882 17.3361C45.9028 19.0507 46.8661 21.3762 46.8661 23.8011C46.8661 26.2259 45.9028 28.5514 44.1882 30.266C42.4736 31.9807 40.1481 32.9439 37.7232 32.9439C35.2984 32.9439 32.9729 31.9807 31.2582 30.266C29.5436 28.5514 28.5804 26.2259 28.5804 23.8011C28.5804 21.3762 29.5436 19.0507 31.2582 17.3361C32.9729 15.6215 35.2984 14.6582 37.7232 14.6582ZM37.7232 19.2296C36.5108 19.2296 35.348 19.7113 34.4907 20.5686C33.6334 21.4259 33.1518 22.5886 33.1518 23.8011C33.1518 25.0135 33.6334 26.1762 34.4907 27.0335C35.348 27.8909 36.5108 28.3725 37.7232 28.3725C38.9356 28.3725 40.0984 27.8909 40.9557 27.0335C41.813 26.1762 42.2946 25.0135 42.2946 23.8011C42.2946 22.5886 41.813 21.4259 40.9557 20.5686C40.0984 19.7113 38.9356 19.2296 37.7232 19.2296ZM37.7232 35.2296C43.8261 35.2296 56.0089 38.2696 56.0089 44.3725V51.2296H19.4375V44.3725C19.4375 38.2696 31.6204 35.2296 37.7232 35.2296ZM37.7232 39.5725C30.9346 39.5725 23.7804 42.9096 23.7804 44.3725V46.8868H51.6661V44.3725C51.6661 42.9096 44.5118 39.5725 37.7232 39.5725Z",
    fill: "#8F4300"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2372_4122",
    x: 0.401042,
    y: 0.945312,
    width: 74.6667,
    height: 74.6667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.33333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.972549 0 0 0 0 0.952941 0 0 0 0 0.952941 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2372_4122"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2372_4122",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLogo);
export default __webpack_public_path__ + "static/media/UserLogo.aa212eea32c4515af93dc6a3e241d88e.svg";
export { ForwardRef as ReactComponent };